import React from "react";
import { Pagination, PaginationItem, PaginationLink } from "reactstrap";

const MAX_VISIBLE = 5; // páginas visibles alrededor de la actual

const CustomPagination = ({ itemsPerPage, totalItems, paginate, currentPage }) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalItems === 0) return null;

  const firstItem = (currentPage - 1) * itemsPerPage + 1;
  const lastItem = Math.min(currentPage * itemsPerPage, totalItems);

  // Calcular rango de páginas visibles
  const getPageRange = () => {
    const half = Math.floor(MAX_VISIBLE / 2);
    let start = Math.max(1, currentPage - half);
    let end = Math.min(totalPages, start + MAX_VISIBLE - 1);
    // Ajustar si end tocó el límite
    if (end - start < MAX_VISIBLE - 1) {
      start = Math.max(1, end - MAX_VISIBLE + 1);
    }
    const pages = [];
    for (let i = start; i <= end; i++) pages.push(i);
    return { pages, start, end };
  };

  const { pages, start, end } = getPageRange();

  return (
    <div className="d-flex justify-content-between align-items-center mt-3">
      {/* Info de registros */}
      <small className="text-muted">
        Mostrando {firstItem}–{lastItem} de {totalItems} registros
      </small>

      {totalPages > 1 && (
        <nav>
          <Pagination className="mb-0" size="sm">
            {/* Primera página */}
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink
                first
                onClick={() => paginate(1)}
                style={{ cursor: "pointer" }}
              />
            </PaginationItem>

            {/* Anterior */}
            <PaginationItem disabled={currentPage === 1}>
              <PaginationLink
                previous
                onClick={() => paginate(currentPage - 1)}
                style={{ cursor: "pointer" }}
              />
            </PaginationItem>

            {/* Elipsis izquierdo */}
            {start > 1 && (
              <PaginationItem disabled>
                <PaginationLink>…</PaginationLink>
              </PaginationItem>
            )}

            {/* Páginas visibles */}
            {pages.map((number) => (
              <PaginationItem key={number} active={number === currentPage}>
                <PaginationLink
                  onClick={() => paginate(number)}
                  style={{ cursor: "pointer" }}
                >
                  {number}
                </PaginationLink>
              </PaginationItem>
            ))}

            {/* Elipsis derecho */}
            {end < totalPages && (
              <PaginationItem disabled>
                <PaginationLink>…</PaginationLink>
              </PaginationItem>
            )}

            {/* Siguiente */}
            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink
                next
                onClick={() => paginate(currentPage + 1)}
                style={{ cursor: "pointer" }}
              />
            </PaginationItem>

            {/* Última página */}
            <PaginationItem disabled={currentPage === totalPages}>
              <PaginationLink
                last
                onClick={() => paginate(totalPages)}
                style={{ cursor: "pointer" }}
              />
            </PaginationItem>
          </Pagination>
        </nav>
      )}
    </div>
  );
};

export default CustomPagination;
